/* hy-hero: smooth-scroll CTA links (href="#id"). Falls back to the section after the hero when the id is missing. */
if (!window.hyScrollBound) {
window.hyScrollBound = true;
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[data-hy-scroll]');
  if (!a) return;
  var hash = a.getAttribute('href') || '';
  if (hash.charAt(0) !== '#') return;
  var target = hash.length > 1 ? document.getElementById(hash.slice(1)) : null;
  var byId = !!target;
  if (!target) {
    var sec = a.closest('.shopify-section');
    target = sec && sec.nextElementSibling;
    while (target && target.offsetHeight === 0) target = target.nextElementSibling;
  }
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  if (byId) history.replaceState(null, '', hash);
});
}
